import React, { SVGProps } from "react";

export default function SupImage(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6 6.8C7.6 7.68366 6.88366 8.4 6 8.4C5.11634 8.4 4.4 7.68366 4.4 6.8C4.4 5.91634 5.11634 5.2 6 5.2C6.88366 5.2 7.6 5.91634 7.6 6.8ZM6.8 6.8C6.8 7.24183 6.44183 7.6 6 7.6C5.55817 7.6 5.2 7.24183 5.2 6.8C5.2 6.35817 5.55817 6 6 6C6.44183 6 6.8 6.35817 6.8 6.8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2 2C3.43269 2 2 3.43269 2 5.2V14.8C2 16.5673 3.43269 18 5.2 18H14.8C16.5673 18 18 16.5673 18 14.8V2H5.2ZM17.2 2.8H5.2C3.87452 2.8 2.8 3.87452 2.8 5.2V13.8907L7.16083 9.8932L9.57844 11.5049L13.5839 8.30054L17.2 10.8317V2.8ZM5.2 17.2C3.93184 17.2 2.89341 16.2164 2.80596 14.9705L7.23901 10.9068L9.62141 12.4951L13.6159 9.29945L17.2 11.8083V14.8C17.2 16.1255 16.1255 17.2 14.8 17.2H5.2Z"
        fill="currentColor"
      />
    </svg>
  );
}
